import loadable from '@loadable/component';
import Loading from '../components/Loader';
import { getBunningsCategoryData } from '../actions/directEnquiry';
import { fetchQuestions } from '../actions/questions';
import { getBunningsStores } from '../actions/storeLocations';
import { checkLoginInfo } from '../actions/user';

const GetQuotesBunningsCategory = loadable(
  () => import(/* webpackChunkName: "gqbunnings" */ '../pages/GetQuotesBunningsCategory'),
  { fallback: Loading }
);

GetQuotesBunningsCategory.needs = (props, { dispatch }) => {
  const key = props.params[0];
  const questions = dispatch(fetchQuestions(key));
  const category = dispatch(getBunningsCategoryData(key));
  const stores = dispatch(getBunningsStores());
  const checkLogin = dispatch(checkLoginInfo());
  GetQuotesBunningsCategory.preload();
  return Promise.all([category, questions, stores, checkLogin]);
};
export default GetQuotesBunningsCategory;
